import React, {Component} from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

export default class Html extends Component {

    constructor(props) {
        super(props);
        this.state = {
            html: '',
            copied: false
        }
    }

    componentDidMount() {
        this.props.http.currentIssueHtml()
            .then(html => this.setState({html: html}));
    }

    handleCopy = () => {
        this.setState({copied: true});
    };

    componentWillReceiveProps(newProps) {
        if (this.props.handles !== newProps.handles) {
            this.setState({copied: false});
        }
    }

    render() {
        const buttonClass = `btn btn-sm ${this.state.copied ? 'btn-success' : 'btn-warning'} htmlCopyBtn`;

        return (
            <div>
                <CopyToClipboard text={this.state.html} onCopy={this.handleCopy}>
                    <button className={buttonClass}>Copy to clipboard</button>
                </CopyToClipboard>
                <textarea className="htmlArea" readOnly value={this.state.html} />
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/dashboard/archive/Html.js